import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import "@fontsource/fira-sans";
import "@fontsource/fira-sans/300.css";

function Footer() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goToInicioAndScroll = (targetId) => {
    // Navegar a Inicio
    navigate("/");
    
    // Esperar a que la navegación cargue antes de hacer scroll
    setTimeout(() => {
      const section = document.querySelector(targetId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // 100ms suele ser suficiente
  };

  return (
    <footer className="footer">
      <p className="footer-link" onClick={() => { navigate("/preguntas"); scrollToTop(); }}>
        Preguntas frecuentes
      </p>
      <p className="footer-link" onClick={() => { navigate("/anestesia"); scrollToTop(); }}>
        Acerca de la Anestesia
      </p>
      <p>Aviso de Privacidad</p>
      <p className="footer-link" onClick={() => goToInicioAndScroll("#conoce")}>
        Conócenos
      </p>
      
      <p className="gridOrder">
        <i className="fa-regular fa-copyright"></i>Derechos reservados 2025
      </p>
      
      <p
  className="footer-link"
  onClick={() => {
    window.open(
      "https://www.instagram.com/anestesia_para_pacientes?utm_source=qr&igsh=Z2thZWcwMWRyeHlm",
      "_blank"
    );
    scrollToTop();
    }}
    >
    @anestesia_para_pacientes
  </p>

    </footer>
  );
}

export default Footer;
